const getChildComponents = (components = []) =>
  components.reduce((accumulator, component) => {
    const { childComponents } = component;

    return [...accumulator, component, ...getChildComponents(childComponents)];
  }, []);

export default getChildComponents;
